(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fresh-journal"]) return;
  try {
    
  const centerFreshJournalTopic = (root = document) => {
    root.querySelectorAll('.fresh-journal__topics').forEach((nav) => {
      const active = nav.querySelector('[aria-current="page"]');
      if (!active || nav.scrollWidth <= nav.clientWidth) return;
      const offset = active.getBoundingClientRect().left - nav.getBoundingClientRect().left;
      nav.scrollLeft = Math.max(0, nav.scrollLeft + offset - (nav.clientWidth - active.offsetWidth) / 2);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => centerFreshJournalTopic());
  } else {
    centerFreshJournalTopic();
  }
  document.addEventListener('shopify:section:load', (event) => centerFreshJournalTopic(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fresh-service-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fresh-service-banner')){customElements.define('fresh-service-banner',class extends HTMLElement{connectedCallback(){if(this.dataset.bound)return;this.dataset.bound='true';const b=this.querySelector('button'),g=this.querySelectorAll('.fresh-service-track span'),seed=g[0].innerHTML;const fill=()=>{g[0].innerHTML=seed;while(g[0].getBoundingClientRect().width<this.querySelector('.fresh-service-window').clientWidth){g[0].innerHTML+=seed;}g[1].innerHTML=g[0].innerHTML;};fill();this.observer=new ResizeObserver(fill);this.observer.observe(this);b.onclick=()=>{const p=this.classList.toggle('is-paused');b.setAttribute('aria-pressed',String(p));b.setAttribute('aria-label',p?this.dataset.resume:this.dataset.pause);b.textContent=p?'▶':'Ⅱ';};}disconnectedCallback(){this.observer?.disconnect();delete this.dataset.bound;}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const initializeFreshCleanControls = (root = document) => {
    root.querySelectorAll('slideshow-component.haiven-slideshow--clean-controls').forEach((carousel) => {
      if (carousel.dataset.hfCleanControlsReady) return;
      const slider = carousel.querySelector('.slideshow');
      const button = carousel.querySelector('.slideshow__autoplay');
      if (!slider) return;
      carousel.dataset.hfCleanControlsReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const narrowViewport = window.matchMedia('(max-width: 749px)');
      const updatePauseColor = (event) => {
        if (!button) return;
        const slide = event?.detail?.currentElement || carousel.querySelector('.slideshow__slide[aria-hidden="false"]');
        const caption = slide?.querySelector('.slideshow__text, .haiven-service-slide__caption');
        const foreground = caption ? getComputedStyle(caption).getPropertyValue('--color-foreground').trim() : '';
        button.style.color = narrowViewport.matches && foreground ? `rgb(${foreground})` : '';
      };
      carousel.addEventListener('slideChanged', updatePauseColor);
      narrowViewport.addEventListener('change', updatePauseColor);
      updatePauseColor();
      const pause = () => {
        if (typeof carousel.pause !== 'function') return;
        carousel.pause();
        if (button && typeof carousel.togglePlayButtonState === 'function') {
          carousel.togglePlayButtonState(true);
          carousel.autoplayButtonIsSetToPlay = false;
        }
      };
      customElements.whenDefined('slideshow-component').then(() => {
        if (reducedMotion.matches) pause();
      });
      reducedMotion.addEventListener('change', (event) => {
        if (event.matches) pause();
      });
      slider.addEventListener('keydown', (event) => {
        if (event.key === ' ' && event.target === slider && button) {
          event.preventDefault();
          button.click();
          return;
        }
        if (event.key === 'Escape') {
          pause();
          return;
        }
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.closest('input, textarea, select')) return;
        event.preventDefault();
        slider.focus({ preventScroll: true });
        pause();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const limit = slider.scrollWidth - slider.clientWidth;
        let destination = slider.scrollLeft + direction * slider.clientWidth;
        if (destination < -1) destination = limit;
        if (destination > limit + 1) destination = 0;
        slider.scrollTo({ left: destination, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      });
      let touchStart;
      slider.addEventListener('touchstart', (event) => {
        const point = event.touches[0];
        if (point) touchStart = { x: point.clientX, y: point.clientY };
      }, { passive: true });
      slider.addEventListener('touchmove', (event) => {
        const point = event.touches[0];
        if (!point || !touchStart) return;
        const horizontal = Math.abs(point.clientX - touchStart.x);
        const vertical = Math.abs(point.clientY - touchStart.y);
        if (horizontal > 12 && horizontal > vertical) {
          pause();
          touchStart = undefined;
        }
      }, { passive: true });
      slider.addEventListener('touchend', () => { touchStart = undefined; }, { passive: true });
      slider.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) pause();
      }, { passive: true });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFreshCleanControls());
  } else {
    initializeFreshCleanControls();
  }
  document.addEventListener('shopify:section:load', (event) => initializeFreshCleanControls(event.target));

  } catch(e) { console.error(e); }
})();
})();
